module.exports = __webpack_public_path__ + "img/task_post@2x.10313793.png";